import {
  AnunciantesIcon,
  CampanhasIcon,
  GerenciamentoIcon,
  MonitoramentoIcon,
} from '~/shared';
import { labelMenu, submenu } from '~/types/constants/labelMenu';

export const navList = [
  {
    label: labelMenu.campaigns,
    icon: <CampanhasIcon />,
    href: '/campanhas',
    submenu: true,
    subMenuItems: [
      {
        label: submenu.dashboard,
        href: '/dashboard',
      },
      {
        label: submenu.creation,
        href: '/campanhas',
      },

      {
        label: submenu.reports,
        href: '/relatorios',
      },
      {
        label: submenu.banners,
        href: '/campanhas-ativas',
        submenu: true,
        subMenuItems: [
          {
            label: submenu.actives,
            href: '/campanhas-ativas',
          },
          {
            label: submenu.reports,
            href: '/banners/relatorios',
          },
        ],
      },
      {
        label: submenu.sponsored,
        href: '/patrocinados/dashboard',
        subMenuItems: [
          {
            label: submenu.dashboard,
            href: '/patrocinados/dashboard',
          },
          {
            label: submenu.creation,
            href: '/patrocinados',
          },
          {
            label: submenu.reports,
            href: '/patrocinados/relatorios',
          },
          {
            label: submenu.performance,
            href: '/desempenho-palavras-chaves',
          },
        ],
      },
    ],
  },
  {
    label: submenu.advertisers,
    icon: <AnunciantesIcon />,
    href: '/anunciantes',
  },
  {
    label: labelMenu.monitoring,
    icon: <MonitoramentoIcon />,
    href: '/monitoramento',
  },

  {
    label: labelMenu.users,
    icon: <GerenciamentoIcon />,
    href: '/gerenciamento',
  },
];
